import { createFileRoute } from '@tanstack/react-router'

import { ProfilePage } from '@/pages/profile/profilePage'

export const Route = createFileRoute('/profile')({
	component: ProfilePage,
})
